export const LISTING_ERRORS_MAP = new Map<string, string>([
    ['Remove_Listing_Failed', 'LISTINGS_COMMON.ERRORS.REMOVE_LISTING_FAILED'],
    ['Failed_To_Delete_Listings', 'LISTINGS_COMMON.ERRORS.FAILED_TO_DELETE_LISTINGS'],
    ['Restore_Listings_Failed', 'LISTINGS_COMMON.ERRORS.RESTORE_LISTINGS_FAILED'],
    ['Listing_Removed_Error', 'LISTINGS_COMMON.ERRORS.LISTING_REMOVED_ERROR'],
    ['Listings_Removed_Error', 'LISTINGS_COMMON.ERRORS.LISTINGS_REMOVED_ERROR'],
    ['Listing_Restored_Error', 'LISTINGS_COMMON.ERRORS.LISTING_RESTORED_ERROR'],
    ['Listings_Restored_Error', 'LISTINGS_COMMON.ERRORS.LISTINGS_RESTORED_ERROR']
]);